export default {
  addBtn: '添加动画',
  customize: '自定义动画',
}
